import { render, staticRenderFns } from "./ServiceAccountSummaryNew.vue?vue&type=template&id=2a8c45bc&scoped=true&"
import script from "./ServiceAccountSummaryNew.vue?vue&type=script&lang=js&"
export * from "./ServiceAccountSummaryNew.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAccountSummaryNew.vue?vue&type=style&index=0&id=2a8c45bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8c45bc",
  null
  
)

export default component.exports